import { Base_Url_Route } from "../routesVar";

// مسافر
export const Passenger_Index_Route = Base_Url_Route + "passenger/";
// dispatch
export const Passenger_Dispatch_Route = Passenger_Index_Route + "dispatch/:id";
// سوابق سفر
export const Passenger_TripHistory_Route =
  Passenger_Index_Route + "trip-history";
// نظرسنجی
export const Passenger_Survey_Route = Passenger_Index_Route + "survey/:id";
// جزئیات سفر
export const Passenger_TripDetail_Route =
  Passenger_Index_Route + "trip-detail/:id";
// رزروهای مسافر
export const Passenger_Reserves_Route =
  Passenger_Index_Route + "reserved-sales";
// سفرجاری مسافر
export const Passenger_CurrentTrip_Route =
  Passenger_Index_Route + "current-trip/:id";
// پرداخت
export const Passenger_Payment_Route =
  Passenger_Index_Route + "payment-method/:id";
// پیش پرداخت رزرو
export const Passenger_PrePaymentReserve_Route =
  Passenger_Index_Route + "prePaymentReserve";
